import { render } from "./DisplacementInfoDialog.vue?vue&type=template&id=436cf1f2&ts=true"
import script from "./DisplacementInfoDialog.vue?vue&type=script&lang=ts"
export * from "./DisplacementInfoDialog.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\BuildAgent\\work\\170657b851b0ad53\\Loading\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__